module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[64]429.e253e3d.woff2";